import { render, staticRenderFns } from "./CommunicationsTab.vue?vue&type=template&id=fc1e8ed0&scoped=true&"
import script from "./CommunicationsTab.vue?vue&type=script&lang=js&"
export * from "./CommunicationsTab.vue?vue&type=script&lang=js&"
import style0 from "./CommunicationsTab.vue?vue&type=style&index=0&id=fc1e8ed0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc1e8ed0",
  null
  
)

export default component.exports